import { render } from "./StudyItem.vue?vue&type=template&id=49298822&scoped=true"
import script from "./StudyItem.vue?vue&type=script&lang=js"
export * from "./StudyItem.vue?vue&type=script&lang=js"

import "./StudyItem.vue?vue&type=style&index=0&id=49298822&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49298822"]])

export default __exports__